/**
 * Ensure the middle value is between the left and right values;
 */
export function between(min: number, value: number, max: number): number {
  return Math.max(min, Math.min(value, max));
}

export function roundToPrecision(value: number, precision: number): number {
  return Number(value.toFixed(precision))
}

export function isEqualObject(first: object, second: object): boolean {
  return JSON.stringify(first) === JSON.stringify(second)
}